export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])},
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exam locations"])},
        "exam_locations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exam locations"])},
        "exam_location_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exam location ID:"])},
        "address": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Address:"])},
        "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email address:"])},
        "phone_number": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Phone number:"])},
        "phone_number_extension": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Extension:"])},
        "contact": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contact:"])},
        "status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status:"])},
        "no_data": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No exam location (sublocation) record found"])},
        "pending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pending"])},
        "active": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Active"])},
        "inactive": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In-active"])},
        "add": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add Exam Location"])}
      },
      "fr": {
        "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier"])},
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lieus d’examen"])},
        "exam_locations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["lieus d’examen"])},
        "exam_location_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID du lieu d’examen :"])},
        "address": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse postale :"])},
        "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse courriel :"])},
        "phone_number": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de téléphone :"])},
        "phone_number_extension": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de poste :"])},
        "contact": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Coordonnées"])},
        "status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statut :"])},
        "no_data": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucun lieu d'examen (lieu secondaire) enregistré trouvé"])},
        "pending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["En attente"])},
        "active": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actif"])},
        "inactive": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inactif"])},
        "add": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter un lieu d’examen"])}
      }
    }
  })
}